// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewcontrolNodeStatusEnum } from './BrewcontrolNodeStatusEnum';
import { operatorId } from './Operator';
import { z } from 'zod';
export const brewcontrolNodeId = (z.string());
export const brewcontrolNode = z.object({
    id: brewcontrolNodeId,
    display_name: z.string(),
    credential_hash: z.string().nullable(),
    metadata: z.unknown(),
    created_at: z.date(),
    updated_at: z.date(),
    status: brewcontrolNodeStatusEnum,
    machine_id: z.string().nullable(),
    hostname: z.string().nullable(),
    agent_version: z.string().nullable(),
    last_connected_at: z.date().nullable(),
    last_disconnected_at: z.date().nullable(),
    credential_issued_at: z.date().nullable(),
    credential_revoked_at: z.date().nullable(),
    enrolment_token_hash: z.string().nullable(),
    enrolment_token_expires_at: z.date().nullable(),
    enrolment_token_used_at: z.date().nullable(),
    event_next_seq: z.string(),
    controller_catalog: z.unknown().nullable(),
    catalog_agent_version: z.string().nullable(),
    device_catalog: z.unknown().nullable(),
    routine_catalog: z.unknown().nullable(),
    log_next_id: z.string(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const brewcontrolNodeInitializer = z.object({
    id: brewcontrolNodeId.optional(),
    display_name: z.string(),
    credential_hash: z.string().optional().nullable(),
    metadata: z.unknown().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    status: brewcontrolNodeStatusEnum.optional(),
    machine_id: z.string().optional().nullable(),
    hostname: z.string().optional().nullable(),
    agent_version: z.string().optional().nullable(),
    last_connected_at: z.date().optional().nullable(),
    last_disconnected_at: z.date().optional().nullable(),
    credential_issued_at: z.date().optional().nullable(),
    credential_revoked_at: z.date().optional().nullable(),
    enrolment_token_hash: z.string().optional().nullable(),
    enrolment_token_expires_at: z.date().optional().nullable(),
    enrolment_token_used_at: z.date().optional().nullable(),
    event_next_seq: z.string().optional(),
    controller_catalog: z.unknown().optional().nullable(),
    catalog_agent_version: z.string().optional().nullable(),
    device_catalog: z.unknown().optional().nullable(),
    routine_catalog: z.unknown().optional().nullable(),
    log_next_id: z.string().optional(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const brewcontrolNodeMutator = z.object({
    id: brewcontrolNodeId.optional(),
    display_name: z.string().optional(),
    credential_hash: z.string().optional().nullable(),
    metadata: z.unknown().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    status: brewcontrolNodeStatusEnum.optional(),
    machine_id: z.string().optional().nullable(),
    hostname: z.string().optional().nullable(),
    agent_version: z.string().optional().nullable(),
    last_connected_at: z.date().optional().nullable(),
    last_disconnected_at: z.date().optional().nullable(),
    credential_issued_at: z.date().optional().nullable(),
    credential_revoked_at: z.date().optional().nullable(),
    enrolment_token_hash: z.string().optional().nullable(),
    enrolment_token_expires_at: z.date().optional().nullable(),
    enrolment_token_used_at: z.date().optional().nullable(),
    event_next_seq: z.string().optional(),
    controller_catalog: z.unknown().optional().nullable(),
    catalog_agent_version: z.string().optional().nullable(),
    device_catalog: z.unknown().optional().nullable(),
    routine_catalog: z.unknown().optional().nullable(),
    log_next_id: z.string().optional(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=BrewcontrolNode.js.map